


export const toggleScroll = () => {
  const overlays = document.querySelectorAll('.overlay');

  if (overlays.length > 0) {
    document.body.classList.add('no-scroll');
  } else {
    document.body.classList.remove('no-scroll');
  }
};

export const convertImgToBase64 = (inputFile) => {
  if (inputFile === undefined) return '';
  const file = new FileReader();

  return new Promise((resolve, reject) => {
    file.onerror = () => {
      file.abort();
      reject(new DOMException('Problem parsing input file.'));
    };

    file.onload = () => {
      resolve(file.result);
    };
    file.readAsDataURL(inputFile);
  });
};

export const formatTableNameFromCamelCase = (camelCaseString) => {
  if (Array.isArray(camelCaseString)) {
    return camelCaseString.map((s) => formatTableNameFromCamelCase(s));
  }
  return camelCaseString
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
};

export const formatTableHeaderToCamelCase = (headers) => {
  if (Array.isArray(headers)) {
    return headers.map((s) => formatTableHeaderToCamelCase(s));
  }
  return headers
    .split(' ')
    .map((header, index) => {
      const smallCaseTerms = ['in', 'at', 'on', 'of', 'to'];
      if (index === 0 || smallCaseTerms.includes(header.toLowerCase()))
        return header.toLowerCase();
      return header.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
    })
    .join('');
};

export const stripCommas = (val) => {
  let num = String(val).replace(/,/g, '')
  return parseFloat(num);
}

export const formatFileUrl = (path) =>
  `${process.env.REACT_APP_BACKEND_URL}/${path}`;

export const numberWithCommas = (x) => {
  if (x === '') {
    return
  }
  if (String(x).includes(',')) {
    return String(x)?.replace(/,/g, '')?.toString()?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
  else {
    return x?.toString()?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");

  }

}

export const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const months =
  [
    {
      value: 1,
      label: "January"
    },
    {
      value: 2,
      label: "February"
    },
    {
      value: 3,
      label: "March"
    },
    {
      value: 4,
      label: "April"
    },
    {
      value: 5,
      label: "May"
    },
    {
      value: 6,
      label: "June"
    },
    {
      value: 7,
      label: "July"
    },
    {
      value: 8,
      label: "August"
    },
    {
      value: 9,
      label: "September"
    },
    {
      value: 10,
      label: "October"
    },
    {
      value: 11,
      label: "November"
    },
    {
      value: 12,
      label: "December"
    },

  ]

export const years = [
  {
    value: 2024,
    label: "2024"
  }
]

export const getDeptName = (id) => {
  if (id == 1) {
    return 'DFA'
  }
  if (id == 2) {
    return 'Internal Auditor'
  }
  if (id == 3) {
    return 'Final Account'
  }
  if (id == 5) {
    return 'Accountant General'
  }
  if (id == 4) {
    return 'Expenditure Control'
  }
  if (id == 6) {
    return 'Management Account'
  }
  if (id == 7) {
    return 'Treasury Cash Account'
  }
  if (id == 9) {
    return 'Initiator'
  }
  if (id == 10) {
    return 'PS'
  }
  if (id == 11) {
    return 'Inspectorate'
  }
  if (id == 12) {
    return 'Governor'
  }
}


export const getMonth = (id) => {
  let month = months?.find((item) => item?.value === id)
  return month?.label;
}

export function numberToWords(num) {
  // Handle negative numbers
  if (num < 0) {
    return "Negative " + numberToWords(Math.abs(num));
  }

  // Define an array of number words for units, tens, and hundreds
  const ones = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
  ];
  const teens = [
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];
  const tens = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];

  // Function to convert a three-digit number to words
  function convertThreeDigits(num) {
    const hundreds = Math.floor(num / 100);
    const remaining = num % 100;

    let word = "";
    if (hundreds > 0) {
      word += ones[hundreds] + " hundred ";
    }

    if (remaining > 0) {
      if (remaining < 20) {
        word += ones[remaining];
      } else {
        const tensDigit = Math.floor(remaining / 10);
        const onesDigit = remaining % 10;
        word += tens[tensDigit];
        if (onesDigit > 0) {
          word += " " + ones[onesDigit];
        }
      }
    }

    return word;
  }

  // Separate the number into billions, millions, thousands, dollars, and cents
  const billions = Math.floor(num / 1000000000);
  const millions = Math.floor((num % 1000000000) / 1000000);
  const thousands = Math.floor((num % 1000000) / 1000);
  const dollars = Math.floor(num % 1000);
  const cents = Math.round((num * 100) % 100);

  // Convert each part to words and join them with commas
  let words = "";
  if (billions > 0) {
    words += convertThreeDigits(billions) + " billion ";
  }
  if (millions > 0) {
    words += convertThreeDigits(millions) + " million ";
  }
  if (thousands > 0) {
    words += convertThreeDigits(thousands) + " thousand ";
  }

  if (dollars > 0) {
    words += convertThreeDigits(dollars);
  } else if (words.length === 0) {
    words += "zero";
  }

  words += " naira and ";

  if (cents > 0) {
    words += ones[cents] + " cent";
    if (cents > 1) {
      words += "s";
    }
  } else {
    words += "zero kobo";
  }

  return words.trim();
}




export function getFirstLetters(str) {
  // Split the string into words
  const words = str.split(/\s+/);

  // Extract the first letter of each word, handling empty strings and spaces
  const firstLetters = words
    .map(word => word.charAt(0).toUpperCase())
    .filter(letter => letter); // Remove any empty strings

  // Join the first letters to form the output string
  return firstLetters.join('');
}

export function timeAgo(dateTime) {
  const now = new Date();
  const diffInSeconds = Math.floor((now - dateTime) / 1000);

  if (diffInSeconds < 60) {
    return `${diffInSeconds} second${diffInSeconds !== 1 ? 's' : ''} ago`;
  } else if (diffInSeconds < 3600) {
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
  } else if (diffInSeconds < 86400) {
    const diffInHours = Math.floor(diffInSeconds / 3600);
    return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
  } else {
    const diffInDays = Math.floor(diffInSeconds / 86400);
    return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
  }
}

